<div class="flex flex-col gap-4 border-solid border-b border-x-0 border-t-0 border-shui-base-4 pb-8">
    <span class="text-base font-semibold text-shui-text-strong">{{
        'iro.steps.deal-information.title' | translate
    }}</span>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-[900px]">
        <sh-input-text
            [label]="'iro.steps.deal-type.title' | translate"
            [value]="dealTypeLabel()"
            disabled
        ></sh-input-text>
        @if (isInstrumentOnly()) {
            <sh-input-text
                [label]="'iro.overview.product-line' | translate"
                [value]="productLineLabel()"
                disabled
            ></sh-input-text>
            <sh-input-text
                [label]="'common.general.sold-to-number' | translate"
                [value]="soldTo() ?? ''"
                disabled
            ></sh-input-text>
            <sh-input-text
                [label]="'common.general.ship-to-number' | translate"
                [value]="shipTo() ?? ''"
                disabled
            ></sh-input-text>
        }
        <sh-input-text
            [label]="'common.general.customer-name' | translate"
            [value]="soldToName() ?? ''"
            disabled
        ></sh-input-text>
        <sh-input-text
            [label]="'iro.overview.sold-to-address' | translate"
            [value]="soldToAddress() ?? ''"
            disabled
        ></sh-input-text>
        <sh-input-text
            [label]="'iro.overview.ship-to-address' | translate"
            [value]="shipToAddress() ?? ''"
            disabled
        ></sh-input-text>
    </div>
    @if (materials().length) {
        <span class="text-base font-semibold text-shui-text-strong mt-4">{{
            'iro.overview.materials' | translate
        }}</span>
        <div class="w-full h-[400px]">
            <ag-grid-angular
                [gridOptions]="gridOptions"
                [rowData]="materials()"
                [columnDefs]="colDefs()"
                class="w-full h-full"
            />
        </div>
    }
</div>
